<template>
  <div>
    <div v-if="this.loadingFormSubmit == true" class="loader">Loading...</div>

    <div class="form-container" v-if="this.loadingFormSubmit == false">

      <el-card class="form-card">

            
      <el-form style="width: 465px;" :model="form" ref="form" :rules="rules">
        <div v-if="this.csvMode == false">
          <el-form-item>

              <el-button
              style="margin: 25px"
              v-if="this.canDownloadCsv"
              @click.native="changeFormToCsv()"
            >Upload with excel</el-button>
          </el-form-item>

          <el-form-item label="Image">
            <PictureUpload
             :propertyid="this.propertyid"
              v-on:picture-id="handlePictureid($event)"
              v-on:removePictureId="RemovePictureIdLocally($event)"
            />
          </el-form-item>

          <el-form-item label="Asset Name" prop="machinename">
            <el-input
              class="tst-asset-name"
              v-model="form.machinename"
              :rules="inputRules"
              placeholder="ex: Washing Machine"
              required
              
            ></el-input>
            <p class="h" v-show="warning">Must enter a name</p>
          </el-form-item>

          <el-form-item label="Description">
            <el-input
              class="tst-asset-desc"
              v-model="form.description"
              placeholder="ex: a white residential washing machine"
              
              required
            ></el-input>
          </el-form-item>
          <el-form-item label="qrcodereader">
            <el-button
              v-if="this.form.qrurl == null"
              @click="dialogVisible = true"
            >Associate Qr Code</el-button>
            <el-button v-if="this.form.qrurl != null" class="qrassociated">Qr Code Associated</el-button>
            <el-dialog title="Scan Your QR Code" :visible.sync="dialogVisible" width="80%">
              <QrCodeReader
                v-if="this.dialogVisible == true"
                v-on:qrcodescanned="qrcodescanned($event)"
              />
              <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">Cancel</el-button>
              </span>
            </el-dialog>
            </el-form-item>
<!-- 
           <el-form-item v-if="this.hideFieldsForSubmit == false">
             <p> Custom fields </p>
              <div v-for="(customField, index) in form.customfields" :key="customField.name">
               
                <div class="custom-field-input-div"> 
                  <p class="custom-field-p"> Field title </p>
                    <el-select
                      v-model="form.customfields[index].customfieldtitle"
                      filterable
                      default-first-option
                      placeholder="Choose custom field"
                      @change="handleFieldSelection"
                      >
                      <el-option
                          v-for="existingCustomField in existingCustomFields"
                          :key="existingCustomField.customfieldid" 
                          :value="existingCustomField.customfieldtitle"                          
                          >                 
                         </el-option>
                    </el-select>            

                </div>

                <div class="custom-field-input-div">
                  <p class="custom-field-p"> Field value </p>
                  
                  <el-input class="custom-field-input" v-model="form.customfields[index].customfieldvalue" ></el-input>
                </div>

              <p 
              style="display: inline; margin-left: 15px;" 
              @click="removeField(index, customField)"> x 
              </p>
              </div>
              <a class="add-line" @click="addField"> add custom field </a>
           </el-form-item> 

           <p class="error" v-if="this.customFieldMissingValue == true"> custom field must have a value</p> -->

           
             <el-form-item v-if="this.form.customfields.length > 0">
             <p> Custom fields </p>
              <div v-for="(customField, index) in this.form.customfields" :key="customField.customfieldid">
                   <div class="custom-field-div"> 
                  <p class="custom-field-header"> Field title </p>
                  <p class="custom-field-title" > {{form.customfields[index].customfieldtitle}}</p>
                   </div>
                  <div class="custom-field-div">
                  <p class="custom-field-header"> Field value </p>
                  
                  <el-input class="custom-field-input" v-model="form.customfields[index].customfieldvalue" ></el-input>
                </div>
              </div>
             </el-form-item>

             <el-form-item>
                <router-link
                    class="link-style"
                    :to="{
                          name: 'printqrcodes'
                        }"
                      >
                   Print QR code sheet
                  </router-link>
             </el-form-item>


          <el-form-item>
            <el-button class="tst-create-asset-button" @click.native="SubmitForm()">Create Asset</el-button>
            <el-button class="tst-cancel-button" @click="closeCreateAssetForm()">Cancel</el-button>
          </el-form-item>
        </div>
        </el-form>
      <el-form>
          <div v-if="this.csvMode == true">
           
          <p class="error" v-if="this.csvError != ''"> {{csvError}} </p> 

            <el-form-item label="Download empty excel sheet. Optional">
                <el-button @click.native="downloadExcelSample()"> Download sample file </el-button>
              </el-form-item>

            <el-form-item label="Attach any excel or csv file.">
      <label class="copied-el-button" for="file-upload" >
        Attach file
      </label>

      <input @change="displayFile" style="display:none;" id="file-upload" type="file"/>
           <p class="attached-file" v-if="this.attachedFile != ''"> 
             <i style="margin-right: 12px; font-weight: bold;" class="el-icon-document"> </i>
             {{attachedFile}}</p>
            </el-form-item>
            
          <el-form-item>
              <router-link
                  class="link-style"
                  :to="{
                        name: 'printqrcodes'
                      }"
                    >
                Print QR code sheet
                </router-link>
          </el-form-item>

            <el-form-item label="Upload to automatically add the assets.">
                <el-button @click.native="submitExcelSheet()"> Submit </el-button>
            </el-form-item>

          </div>


        </el-form>

      </el-card>
    </div>
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
import PictureUpload from "@/components/utilities/PictureUploadSingle.vue";
import QrCodeReader from "@/components/utilities/QrCodeReader.vue";
import fab from "vue-fab";
import { error } from 'logrocket';

export default {
  components: {
    fab,
    PictureUpload,
    QrCodeReader
    },
  props: {
    property: Object,
    canDownloadCsv: false
  },
  data() {
    return {
      existingCustomFields: [],
      warning: false,
      csvMode: false,
      dialog: false,
      dialogVisible: false,
      labelStagingarea: [],
      propertyid: this.$route.params.propertyid,
      excelFile: null,
      attachedFile: "",
      customFieldMissingValue: false,
    //  hideFieldsForSubmit: false,
      form: {
        machinename: "",
        model: "",
        description: "",
        propertyid: this.$route.params.propertyid,
        qrurl: null,
        labels: [],
        customfields: [],
        pictureid: []
      },
      csvError: "",
      inputRules: [v => (v && v.length != 0) || "This field is required"],
               rules: {
          machinename: [
            { required: true, message: 'Please input Asset name', trigger: 'blur' },
          ],
       },
       invalid: Boolean,
       loadingFormSubmit: false
    };
  },
  // created() {
  //   this.form.propertyid = this.$route.params.propertyid;
  // },
  mounted(){
    EventService.getPropertyCustomFields( this.$route.params.propertyid).then( response => {

        this.form.customfields = response.data.customfields;

      // this.existingCustomFields = response.data.customfields;
      // this.untouchedExistingCustomFields = JSON.parse(JSON.stringify( this.existingCustomFields));
    })
  },
  methods: {
    changeFormToCsv() {
      this.csvMode = !this.csvMode;
    },
    displayFile(){
      this.csvError = "";
      var file = document.getElementById("file-upload").files["0"]
      this.attachedFile = file.name;
 },
    qrcodescanned($event) {
      this.form.qrurl = $event;
      this.dialogVisible = false;
    },
//     handleFieldSelection(selectedFieldTitle){

//       var formField = this.form.customfields.filter(i => i.customfieldtitle == selectedFieldTitle)[0];
          
//       var indexInFormField = this.form.customfields.indexOf(formField)
        
//       var existingField = this.existingCustomFields.filter(i => i.customfieldtitle == selectedFieldTitle)[0];
          
//       var indexInExisitngField = this.existingCustomFields.indexOf(existingField)
      
//       this.existingCustomFields.splice(indexInExisitngField, 1)

//       if(!formField.customfieldid == null || !formField.customfieldid == "")
//       {
//           this.addBackFieldForSelection(formField.customfieldid);
//       }

//       this.$set(this.form.customfields[indexInFormField], 'customfieldid', existingField.customfieldid);
  
  
//  },
//     addField(){
 
//       var lastInFieldsArray = this.form.customfields[this.form.customfields.length - 1];
      
//       // if there's no field at all let him add
//      if(lastInFieldsArray != undefined){
//              // if the last line isn't filled out or if there's no more existing fields he didnt set, return
//           if(lastInFieldsArray.customfieldvalue == null || lastInFieldsArray.customfieldid == null || this.existingCustomFields.length == 0){
//               return;
//             }
//      }
//       this.form.customfields.push({
//             customfieldid: null,
//             customfieldtitle: null,
//             customfieldvalue: null
//           })
//     },
//     removeField(index, currentField){

//        this.form.customfields.splice(index, 1);
//        if(currentField.customfieldid != null)
//        {
//         this.addBackFieldForSelection(currentField.customfieldid);
//        }
//        },
//     addBackFieldForSelection(fieldId){
//           var earlierRemovedExistingField = this.untouchedExistingCustomFields
//                                     .filter(i => i.customfieldid == fieldId)[0];

//           this.existingCustomFields.push(earlierRemovedExistingField);
//     },
    SubmitForm() {
      if(this.form.machinename < 1){
        this.warning = true
      }

       this.$refs["form"].validate((valid) => {
          if (valid) {
          } else {
            this.invalid = true;
            return false;
          }
        });
        if(this.invalid == true){
          this.invalid = false;
          return;
        }

          // var missingValueInCustomField = this.form.customfields.some(i => (i.customfieldvalue == null || i.customfieldvalue == "") || (i.customfieldid == null || i.customfieldid == ""));

          // if(missingValueInCustomField == true)
          // {
          //   this.customFieldMissingValue = true;
          //   return;
          // }

          // this.existingCustomFields.forEach(customField => {
          
          //     this.hideFieldsForSubmit = true;

          //     this.form.customfields.push({
          //                               customfieldid: customField.customfieldid,
          //                               customfieldvalue: null
          //     });
          // });

      this.loadingFormSubmit = true;

      this.form.labels = this.form.labels.concat(this.labelStagingarea);

        EventService.addAsset(this.form)
            .then(response => {

              // console.log(response)
              // console.log(response.data)
              this.$emit("new-asset", response.data);
              this.clearForm();
              this.closeCreateAssetForm();
              this.$store.dispatch("addNotification", {
                type: "success",
                Message: "Asset added"
              });
            })
            .catch(error => {
              this.closeCreateAssetForm();

              console.log(error)
            });

    },
    downloadExcelSample() {
      console.log("download property csv function is running");
      EventService.GetSpecificPropertyCsvFile(this.property.propertyid).then(
        response => {
          location.href = response.data.presignedurl;
        }
      )
      .catch(error => {
           console.log(error);
      });
    },
    submitExcelSheet(){
          var file = document.getElementById("file-upload").files["0"]

          let formData = new FormData();

          formData.append("file", file);

          EventService.UploadSpecificPropertyCsvFile(
            this.property.propertyid,
            formData
          )
            .then( response =>{
                
                if(response.data.success == false){
                      this.csvError = response.data.message;

                    document.getElementById("file-upload").value = "";

                    this.attachedFile = "";
                }
                else
                {
                    this.$emit("new-asset-list", response.data); 

                    this.clearForm();

                    this.closeCreateAssetForm();
                
                    this.$store.dispatch("addNotification", {
                      type: "success",
                      Message: "Assets added"
                    });
                }

              
          })
          .catch(error =>{
              console.log(error)
          });
          
    },
    getFile(file){
      this.excelFile = file;
      console.log(this.file)
    },
    createAssetLabel(assetLabelObject) {
      this.labelStagingarea.push(assetLabelObject);
    },
    handlePictureid($event) {
      //for (const object of $event) {
      this.form.pictureid.push($event.pictureid);
      //}
    },
    RemovePictureIdLocally(img) {
      this.$delete(this.form.pictureid, this.form.pictureid.indexOf(img));
      // this.form.imageurl.shift();
    },
    addCustomField() {},
    clearForm() {
      this.form = {
        machinename: "",
        model: "",
        description: "",
        propertyid: this.$route.params.propertyid,
        qrurl: null,
        labels: [],
        // customfields: [],
        pictureid: []
      };
      // this.$refs.createAssetForm.resetValidation();
    },
    closeCreateAssetForm() {
      this.$emit("close-CreateAssetForm");
    }
  }
};
</script>

<style scoped>
.qrassociated {
  background-color: lightgreen;
  color: black;
}
.h{
  position: static;
  margin-top: -50px;
 color: rgb(255, 1, 1);
}
   .custom-field-div{
    display: inline-block;
    margin: 0 45px 0 0;
  }
  .custom-field-input{
    margin: 0px 5px;
  }
  .custom-field-header{
    margin: 0px 0px 0px 10px;
  }
  .custom-field-title{
    margin: 0px 0px 0px 20px;
  }
  .add-line{
      text-decoration: underline;
      color: #02746E;
      cursor: pointer;
  }
  #custom-field-input{

      position:relative;
      border-right:none;
      padding:none;
  }
  #custom-field-select{
      border-left:none;
      padding:none;
  }
  .link-style{
    text-decoration: underline;
    color: #02746E;;
  }
  .error{
    color: red;
    font-size: 12px;
    margin: -12px 15px 15px 0px;
  }
.copied-el-button{
      display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #FFF;
    border: 1px solid #DCDFE6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: .1s;
    transition: .1s;
    font-weight: 500;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 4px;
}
</style>
